import hasAccessToThis from 'services/utilFunctions/hasAccessToThis'
import { store } from 'store/reducers'

const flagsPermissionsHandler = (flag: MData.UserFlags): MData.UserFlags | 'MISSING_PERMISSIONS' => {
  const {
    settings: { enableAttributes }
  } = store.getState() as MStore.RootState

  switch (flag) {
    // Skills and attributes
    case 'hasRestrictions':
    case 'missingSkills':
    case 'missingRequirements': {
      if (!hasAccessToThis('attributeSee') || !enableAttributes) return 'MISSING_PERMISSIONS'
      else return flag
    }

    case 'vacationOverlapping':
    case 'eventOverlapping':
    case 'eventDistance':
      return flag
    case 'maxNumberOfHours':
      return flag
    case 'maxNumberOfHoursPerDay':
      return flag
    case 'maxConsecutiveDays':
      return flag

    // Basic rendering
    case 'missingPosition':
    case 'leaveOverlapping':
    case 'unavailableAllDay':
    case 'unavailableOverlap':
    case 'noCurrentAvailability':
    case 'pendingAvailability':
    case 'wrongDepartment':
    case 'wrongTeam':
    case 'wrongProject':
    case 'maxConsecutiveTime':
    case 'missingAdjacentShiftBefore':
    case 'missingAdjacentShiftAfter':
    case 'missingAdjacentShifts':
      return flag
    case 'lockedToProject':
    case 'preferredOnProject':
    case 'lockedToCurrent':
    case 'preferredOnCurrent':
    case 'blockedFromProject':
      if (!hasAccessToThis('projectSee')) return 'MISSING_PERMISSIONS'
      return flag

    // Basic rendering hiring data
    case 'beforeStartDate':
    case 'afterEndDate':
    case 'archivedUser':
    case 'missingRegion':
      if (!hasAccessToThis('userSeeHiringInfo')) return 'MISSING_PERMISSIONS'
      return flag
    case 'noContract':
    case 'noPermit':
    case 'noEmployeeType':
    case 'employeeExpiredContract':
    case 'employeeExpiredPermit':
    case 'expiredEmployeeType':
    case 'employeeTypeInvalid':
      if (!hasAccessToThis('hiringDataSee')) return 'MISSING_PERMISSIONS'
      return flag
    default:
      return flag
  }
}

export default flagsPermissionsHandler
